import { Component, NgModule, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AccountService } from '../../../services/account.service';
import { UserService } from '../../../services/user.service';
import { UserRole } from '../../../models/enums';
import { NavigationService } from '../../../services/navigation.service';
import { NavTitle, NavButton } from '../../../models/navigation.model';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { NavigationEnd, Router ,RouterModule} from '@angular/router';
import { SharedService } from '../../../services/shared.service';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LogoutTimerService } from '../../../services/logout-timer.service';
import { SanitizeInputDirective } from '../../../directives/sanitize-input.directive';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  providers: [UserService]
})
export class NavMenuComponent implements OnInit, OnDestroy {
  isExpanded = false;
  isAdmin = false;
  isLoggedIn = false;
  showNavMenu = true;
  showLeftNav: boolean = false;
  role: UserRole = null;
  navTitle: NavTitle;
  isReporting = false;
  isLoading: boolean = false;

  showButton: boolean = false;
  button: NavButton;
  isBulkEdit:boolean = false;
  isAccountingBulkEdit:boolean = false;
  isAccountingNav:boolean = false;
  isReadyToDispatch:boolean = false;
  isOrderInProcess:boolean = false;

  showFilter: boolean = false;
  filter: string = '';
  filterChanged = new Subject<string>();
  status = null;
  currentModule:string = null;
  public href: string = "";
  subscription:Subscription
  beginBulkEditSubscription:Subscription;
  beginAccountingBulkEditSubscription:Subscription;
  isBeginAccountingBulkEditEnable = true;
  isBeginBulkEditEnable = true;
  sharedServiceClient: SharedService;
  proxyOptions: any[]=[];
  selectedProxy: any[]=[];
  private previousProxySelection: any[] = [];
  @ViewChild(MultiSelect) multiSelect: MultiSelect;

  constructor( private logoutTimerService: LogoutTimerService,private accountService: AccountService, private navigationService: NavigationService, private router: Router, private renderer: Renderer2, private sharedService: SharedService, private userService: UserService
  ) {
    this.sharedServiceClient = sharedService;
    this.sharedService.loading$.subscribe(state => {
      this.isLoading = state; 
    });
  }

  ngOnInit() {
    this.previousProxySelection = [];

    this.userService.fetchAssignRepData().subscribe((r)=>{
      this.proxyOptions = r?.body?.map(proxy => ({
        label: proxy.fullName || proxy.label,
        value: proxy.userId || proxy.value,
      }));
    })

    this.updateRouteData(this.router.url);
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url) {
          this.updateRouteData(event.url);
        }
      }
    });
    this.accountService.isAdmin$.subscribe(s => {
      this.isAdmin = s;
    });

   this.navigationService.leftNav$.subscribe(v => {
     if (v.area != "orders") {
       this.selectedProxy = [];
       this.previousProxySelection = [];
       this.navigationService.setProxyForValue([]);
     }
   })

    this.accountService.isLoggedIn$.subscribe(s => {
      this.isLoggedIn = s;
      if (s) {
        this.initializeMidnightLogout();
        this.role = UserRole[localStorage.getItem('userRole')];
      } else {
        this.logoutTimerService.stopLogoutTimer();
      }
    });

    if (typeof window !== 'undefined') {
      setInterval(() => {
        const status = this.logoutTimerService.getTimerStatus();
        if (status.isActive) {
          //console.log('12:00 AM logout timer status:', status);
        }
      }, 30000);
    }

    this.navigationService.navTitle$.subscribe(s => {
      this.isReporting = s.title.includes("Report");
      this.isBeginBulkEditEnable = true;
      this.isBeginAccountingBulkEditEnable = true;
      if (s.title.includes("Ready To Dispatch")) {
        this.isReadyToDispatch = true;
        this.isBulkEdit = true;
      } else {
        this.isReadyToDispatch = false;
        this.isBulkEdit = false;
      }
      if(s.title.includes("Order In Process")){
        this.isOrderInProcess = true
      }else{
        this.isOrderInProcess = false
      }

      this.sharedServiceClient.setCheckBoxStatusBulkEdit(false);
      if (s.title.includes("Accounts Receivable") || s.title.includes("Customer Billing") || s.title.includes("Late Customer Payment")) {
        this.isAccountingNav = true;
        this.isAccountingBulkEdit = true;
      } else {
        this.isAccountingNav = false;
        this.isAccountingBulkEdit = false;
      }
      this.sharedService.setCheckBoxStatusBulkEdit(false);
      this.sharedService.setCheckBoxStatusAccoutingBulkEdit(false);
      this.navTitle = s;
    });

    this.navigationService.subnavTitle$.subscribe(s =>{
      if (s) {
        this.navTitle.subtitle = s;
      }
    })

    this.navigationService.showTopNav$.subscribe(s => {
      this.showNavMenu = s;
    })

    this.navigationService.showLeftNav$.subscribe(s => {
      this.showLeftNav = s;
    })

    this.navigationService.showButton$.subscribe(s => {
      this.showButton = s;
    });

    this.navigationService.showFilter$.subscribe(s => {
      this.showFilter = s;
    });

    this.navigationService.navButton$.subscribe(s => {
      this.button = s;
    });

    this.filterChanged.pipe(debounceTime(1000)).subscribe(() => {
      this.navigationService.setFilter(this.filter);
    });

    this.navigationService.clearFilter$.subscribe(s => {
      this.filter = null;
      this.navigationService.setFilter(this.filter);
    });
    this.beginBulkEditSubscription = this.navigationService.isBeginBulkEditEnable$.subscribe(s => {
      this.isBeginBulkEditEnable = s;
    });
    this.beginAccountingBulkEditSubscription = this.navigationService.isBeginAccountingBulkEditEnable$.subscribe(s => {
      this.isBeginAccountingBulkEditEnable = s;
    });
  }


  initializeMidnightLogout(){    
    this.logoutTimerService.startLogoutAtMidnight(() => {
      this.performLogout();
    });
  }
  updateRouteData(url: string) {
    const segments = url.split('/');
    this.currentModule = segments[1] || null;
    this.status = segments[3] ? this.sharedService.getTenderStatus(segments[3]) : null;
  }



   private performLogout(): void {
    try {
      this.accountService.logout();
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login']);
    } catch (error) {
      this.router.navigate(['/login']);
    }
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.beginBulkEditSubscription?.unsubscribe();
    this.beginAccountingBulkEditSubscription?.unsubscribe();
    this.navigationService.setProxyForValue([]);
    this.logoutTimerService.stopLogoutTimer();
}

  filterChange(e: any) {
    this.filter = e?.trim();
    this.filterChanged.next(null);
  }

  logout() {
    this.accountService.logout();
  }

  collapse() {
    this.isExpanded = false;
  }

  toggleLeftNav() {
    this.showLeftNav = !this.showLeftNav;
    this.navigationService.showLeftNav(this.showLeftNav);
  }

  click() {
    this.navigationService.clickButton(null);
  }


  clickNewOrder() {
    this.navigationService.clickNewOrderButton(null);

  }

  clickNewUser() {
    this.navigationService.clickNewUserButton(null);
  }

  clickNewLocation() {
    this.navigationService.clickNewLocationButton(null);
  }

  clickCancel(){
    this.navigationService.clickCancelButton(null);
  }

  clickActive(){
    this.navigationService.clickActiveButton(null);
  }
  getCurrentMode() {
    return localStorage.getItem('isDarkMode') && localStorage.getItem('isDarkMode') === 'true'
  }

  clickBulkEdit() {
    this.isBulkEdit = !this.isBulkEdit;
    if (this.isBulkEdit) {
      this.isBeginBulkEditEnable = true;
    }
    this.sharedServiceClient.setCheckBoxStatusBulkEdit(!this.isBulkEdit);
  }
  clickBeginBulkEdit(){
    this.navigationService.clickBeginBulkEditButton(true);
  }

  clickAccountingBulkEdit() {
    this.isAccountingBulkEdit = !this.isAccountingBulkEdit;
    if (this.isAccountingBulkEdit) {
      this.isBeginAccountingBulkEditEnable = true;
      this.navigationService.clickCancelInvoiceBulkButton(true)
    }
    this.sharedService.setCheckBoxStatusAccoutingBulkEdit(
      !this.isAccountingBulkEdit
    );
  }
  
  clickBeginAccountingBulkEdit(){
    this.navigationService.clickBeginAccountingBulkEditButton(true);
  }

  switchMode() {
    const isDarkMode = localStorage.getItem('isDarkMode');
    if (isDarkMode && isDarkMode === 'true') {
      this.renderer.removeClass(document.body, 'dark-theme');
      localStorage.setItem('isDarkMode', 'false');
    } else {
      this.renderer.addClass(document.body, 'dark-theme');
      localStorage.setItem('isDarkMode', 'true');
    }
  }

  onAgentDropDownSelect(e){
    this.selectedProxy = e;
    this.previousProxySelection = [...e];
  }

  assignSelectedReps() {
    this.navigationService.setProxyForValue(this.selectedProxy);
  }

  selectAllAgents() {
    // If there's a filter active, only select filtered options
    if (this.multiSelect && this.multiSelect.filterValue) {
      const filteredOptions = this.proxyOptions.filter(option => 
        option.label.toLowerCase().includes(this.multiSelect.filterValue.toLowerCase())
      );
      this.selectedProxy = filteredOptions.map(option => option.value);
    } else {
      // No filter, select all options
      this.selectedProxy = this.proxyOptions.map(option => option.value);
    }
    this.previousProxySelection = [...this.selectedProxy];
  }

  clearAllAgents() {
    this.selectedProxy = [];
    this.previousProxySelection = [];
  }
}

@NgModule({
  declarations: [
    NavMenuComponent,
  ],
  imports: [
    CommonModule,
    MultiSelectModule,
    RouterModule,
    FormsModule,
    SanitizeInputDirective
  ],
  exports: [
    NavMenuComponent
  ]
})
export class NavMenuModule { }
